import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.tsx";
import "./styles/landing.css";
import "./styles/replica.css";
import "./styles/why-gates.css";
import "./styles/why-now.css";
import "./styles/why-matterline.css";
import "./styles/agent-comparison.css";
import "./styles/trial-application.css";
import "./styles/invitation-download.css";
import "./styles/internal-registration.css";
import "./styles/desktop-platform.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
